import { useFormContext } from 'react-hook-form';
import SingleSelectInput from '@/components/form/SingleSelectInput.tsx';
import { ValueInput } from '@/components/form/ValueInput.tsx';
import { DateInput } from '@/components/form/DateInput.tsx';
import { TextareaInput } from '@/components/form/TextareaInput.tsx';
import TwoInputsRow from '@/components/form/ui/TwoInputsRow.tsx';
import TourSearchSelectRHF from '@/components/asyncSelect/entitySelects/TourSearchSelectRHF.tsx';
import { ExpenseInputData } from '@/features/dashboard/expenses/schemas/expenseSchema.ts';
import useGetCostCategoryOptions from '@/features/dashboard/expenses/hooks/useGetCostCategoryOptions.ts';
import { currencySelectOptions } from '@/features/dashboard/paymentConfig/types/Currency.utils.ts';

interface ExpenseFormProps {
  showTourSelect?: boolean;
}

const ExpenseForm = ({ showTourSelect = false }: ExpenseFormProps) => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<ExpenseInputData>();

  const { options: costCategoryOptions } = useGetCostCategoryOptions();

  return (
    <>
      {showTourSelect && (
        <TourSearchSelectRHF
          fieldPathName="tourId"
          control={control}
          label="Wyjazd"
          required
          placeholder="Wyszukaj wyjazd..."
          error={errors.tourId?.message}
        />
      )}

      <SingleSelectInput
        fieldName="costCategoryId"
        control={control}
        options={costCategoryOptions}
        label="Kategoria kosztów"
        required
        error={errors.costCategoryId?.message}
        placeholder="Wybierz kategorię..."
      />

      <TwoInputsRow ratio="2/1">
        <ValueInput
          label="Kwota"
          register={register('amount', { valueAsNumber: true })}
          placeholder="0"
          required
          type="number"
          step={0.01}
          error={errors.amount?.message}
        />
        <SingleSelectInput
          fieldName="currency"
          control={control}
          options={currencySelectOptions}
          label="Waluta"
          required
          error={errors.currency?.message}
        />
      </TwoInputsRow>

      <DateInput
        dateFieldName="dueDate"
        control={control}
        label="Termin płatności"
        required
        error={errors.dueDate?.message}
      />

      <TextareaInput
        label="Opis"
        register={register('description')}
        error={errors.description?.message}
        placeholder="Dodatkowe informacje..."
      />
    </>
  );
};

export default ExpenseForm;
